import TagGroupSection from 'components/Tags/TagGroupSection';
import useActions from 'hooks/useActions';
import { useNavigate } from 'react-router-dom';

const { connect } = require('react-redux');

function mapStateToProps(state) {
    return {
        article: state.CSQuestions.selectedQuestion,
        tagGroups: state.CSTags.tagGroups,
    };
}

const CSQuestionTags = connect(mapStateToProps)(function (props) {
    const { article, tagGroups } = props;

    const {
        CS_ADD_TAG_TO_QUESTION_REQUEST,
        CS_REMOVE_TAG_FROM_QUESTION_REQUEST,
        //PE_SELECT_TAG_GROUP,
    } = useActions();

    const navigate = useNavigate();

    function onAdd(tagId) {
        CS_ADD_TAG_TO_QUESTION_REQUEST({
            questionId: article.id,
            tagId,
        });
    }

    function onRemove(tagId) {
        CS_REMOVE_TAG_FROM_QUESTION_REQUEST({
            questionId: article.id,
            tagId,
        });
    }

    function onSelectTagGroup(tagGroup) {
        //PE_SELECT_TAG_GROUP(tagGroup);
        navigate(`/community/tags/tag/new/${tagGroup.id}`);
    }

    return (
        <section>
            {tagGroups &&
                tagGroups.map((tagGroup) => (
                    <TagGroupSection
                        key={tagGroup.id}
                        tagGroup={tagGroup}
                        selectedTags={article?.tags}
                        onAdd={onAdd}
                        onRemove={onRemove}
                        onSelectTagGroup={onSelectTagGroup}
                    />
                ))}
        </section>
    );
});

export default CSQuestionTags;
